var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBuildHome = function SvgBuildHome(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    fill: "none",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "m3.358 7.999 10.667-6v12zm12.444-6c0-.694-.316-1.337-.844-1.7A1.6 1.6 0 0 0 13.23.212l-10.666 6c-.606.337-.984 1.03-.984 1.787s.378 1.45.984 1.788l10.666 6c.55.312 1.206.274 1.728-.088.522-.363.844-1.006.844-1.7v-5h4.89c0 1.106.794 2 1.777 2h4.889c1.472 0 2.667-1.344 2.667-3s-1.195-3-2.667-3h-4.889c-.983 0-1.778.894-1.778 2h-4.889zm11.556 5c.489 0 .889.45.889 1s-.4 1-.889 1h-4.889v-2zm-9.778 17h10.667v6H15.802v-6zm-3.555 0v6H3.358v-6zm14.222-2h-8.889v-6h8.889zm-10.667-6v6H3.358c-.983 0-1.778.894-1.778 2v6c0 1.106.795 2 1.778 2h24.889c.983 0 1.778-.894 1.778-2v-14c0-1.106-.795-2-1.778-2h-8.889c-.983 0-1.778.894-1.778 2"
  })));
};
export default SvgBuildHome;